import { inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivateFn,
    RouterStateSnapshot,
} from '@angular/router';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { RoutingHelpersService } from '@polaris-customerweb/sharedcomponents.shared';
import { Observable, of } from 'rxjs';

export const epiRedirectGuard: CanActivateFn = (
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
): Observable<boolean> => {
    const configService = inject(ConfigService);
    const routingHelpersService = inject(RoutingHelpersService);

    if (configService.isEpi) {
        window.location.href = routingHelpersService.combineUrl(
            configService.siteUrl,
            state.url
        );

        return of(false);
    }

    return of(true);
};
